// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixed-plugin li > a,
.fixed-plugin .badge{
    transition: all .34s;
    -webkit-transition: all .34s;
    -moz-transition: all .34s;
}

.all-icons [class*="pe-"]{
    font-size: 40px;
}
.all-icons input{
    border: 0;
}
.all-icons .font-icon-detail{
    text-align: center;
    padding: 45px 0px 30px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    margin: 15px 0;
}
.all-icons .font-icon-detail input{
    margin: 25px auto 0;
    width: 100%;
    text-align: center;
    display: block;
    color: #aaa;
    font-size: 13px;
}

#map{
    position:relative;
    width:100%;
    height: calc(100% - 60px);
}

.places-buttons .btn{
    margin-bottom: 30px
}
.sidebar .nav > li.active-pro{
    position: absolute;
    width: 100%;
    bottom: 10px;
}
.sidebar .nav > li.active-pro a{
    background: rgba(255, 255, 255, 0.14);
    opacity: 1;
    color: #FFFFFF;
}

.table-upgrade td:nth-child(2),
.table-upgrade td:nth-child(3){
    text-align: center;
}

.fixed-plugin{
    position: absolute;
    top: 180px;
    right: 0;
    width: 64px;
    background: rgba(0,0,0,.3);
    z-index: 1031;
    border-radius: 8px 0 0 8px;
    text-align: center;
}
.fixed-plugin .fa-cog{
    color: #FFFFFF;
    padding: 10px;
    border-radius: 0 0 6px 6px;
    width: auto;
}
.fixed-plugin .dropdown-menu{
    right: 80px;
    left: auto;
    width: 290px;
    border-radius: 10px;
    padding: 0 10px;
}
.fixed-plugin .dropdown-menu:after, .fixed-plugin .dropdown-menu:before{
    right: 10px;
    margin-left: auto;
    left: auto;
}
.fixed-plugin .fa-circle-thin{
    color: #FFFFFF;
}
.fixed-plugin .active .fa-circle-thin{
    color: #00bbff;
}

.footer-dropdown{
	top: -120px !important;
}

.footer-dropdown:before, .footer-dropdown:after{
	top: 300px !important;
}

.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus{
    color: #777777;
    text-align: center;
}

.fixed-plugin img{
    border-radius: 0;
    width: 100%;
    max-height: 175px;
    margin: 0 auto;
}

.fixed-plugin .badge{
    border: 3px solid #FFFFFF;
    border-radius: 50%;
    cursor: pointer;
    display: inline-block;
    height: 23px;
    margin-right: 5px;
    position: relative;
    width: 23px;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover{
    border-color: #00bbff;
}

.fixed-plugin .badge-white{
    background-color: #FFFFFF;
}
.fixed-plugin .badge-black{
    background-color: #1DC7EA;
}
.fixed-plugin .badge-azure{
    background-color: #1DC7EA;
}
.fixed-plugin .badge-green{
    background-color: #87CB16;
}
.fixed-plugin .badge-orange{
    background-color: #FFA534;
}
.fixed-plugin .badge-purple{
    background-color: #9368E9;
}
.fixed-plugin .badge-red{
    background-color: #FB404B;
}
.fixed-plugin h5{
    font-size: 14px;
    margin: 10px;
}
.fixed-plugin .dropdown-menu li{
    display: block;
    padding: 5px 2px;
    width: 25%;
    float: left;
}

.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container{
    width: 100%;
    height: 50px;
    min-height: inherit;
}
.fixed-plugin .pro-title{
    margin: 10px 0 5px 0;
    text-align: center;
}

.fixed-plugin #sharrreTitle{
    text-align: center;
    padding: 10px 0;
    height: 50px;
}

.fixed-plugin li.header-title{
    height: 30px;
    line-height: 40px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.fixed-plugin .adjustments-line p{
    float: left;
    display: inline-block;
    margin-bottom: 0;
    font-size: 1em;
}
.fixed-plugin .adjustments-line .switch{
    float: right;
}
.fixed-plugin .dropdown-menu > li.adjustments-line > a{
      padding-right: 0;
      padding-left: 0;
      border-bottom: 1px solid #ddd;
      margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder{
      font-size: 16px;
      text-align: center;
      border-radius: 10px;
      background-color: #FFF;
      border: 3px solid #FFF;
      padding-left: 0;
      padding-right: 0;
      opacity: 1;
      cursor: pointer;
      max-height: 86px;
      overflow: hidden;
      padding: 0;
}

.fixed-plugin .dropdown-menu > li > a.switch-trigger:hover,
.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus{
    background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder,
.fixed-plugin .dropdown-menu > li:focus > a.img-holder{
    border-color: rgba(0, 187, 255, 0.53);;
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder{
    border-color: #00bbff;
    background-color: #FFFFFF;
}

.fixed-plugin .dropdown-menu > li > a img{
    margin-top: auto;
}

.fixed-plugin .btn-social{
    width: 50%;
    display: block;
    width: 48%;
    float: left;
    font-weight: 600;
}
.fixed-plugin .btn-social i{
    margin-right: 5px;
}
.fixed-plugin .btn-social:first-child{
    margin-right: 2%;
}

.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus{
    opacity: 1;
}


@media (min-width: 992px){
    .fixed-plugin .dropdown .dropdown-menu{
         transform: translateY(-50%);
         top: 27px;
         opacity: 0;

         transform-origin: 0 0;
    }
    .fixed-plugin .dropdown.open .dropdown-menu{
         opacity: 1;
         transform: translateY(-50%);

         transform-origin: 0 0;
    }

    .fixed-plugin .dropdown-menu:before,
    .fixed-plugin .dropdown-menu:after{
        content: "";
        display: inline-block;
        position: absolute;
        top: 50%;
        width: 16px;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);

    }
    .fixed-plugin .dropdown-menu:before{
        border-bottom: 16px solid rgba(0, 0, 0, 0);
        border-left: 16px solid rgba(0,0,0,0.2);
        border-top: 16px solid rgba(0,0,0,0);
        right: -16px;
    }

    .fixed-plugin .dropdown-menu:after{
        border-bottom: 16px solid rgba(0, 0, 0, 0);
        border-left: 16px solid #FFFFFF;
        border-top: 16px solid rgba(0,0,0,0);
        right: -15px;
    }

    .typo-line{
        padding-left: 140px;
        margin-bottom: 40px;
        position: relative;
    }

    .typo-line .category{
        transform: translateY(-50%);
        top: 50%;
        left: 0px;
        position: absolute;
    }

    .fixed-plugin{
        top: 300px;
    }

}

@media (max-width: 991px){
    .fixed-plugin .dropdown-menu{
        right: 60px;
        width: 220px;
    }
    .fixed-plugin .dropdown-menu li{
        width: 50%;
    }

    .fixed-plugin li.adjustments-line,
    .fixed-plugin li.header-title,
    .fixed-plugin li.button-container{
        width: 100%;
        height: 55px;
        min-height: inherit;
    }

    .fixed-plugin .adjustments-line .switch{
        float: right;
        margin: 0 0px;
    }

    .fixed-plugin li.header-title{
        height: 40px;
    }
    .fixed-plugin .dropdown .dropdown-menu{
        top: -170px;
    }
}

.btn-social {
  opacity: 0.85;
  padding: 8px 9px;
}
.btn-social .fa {
  font-size: 18px;
  vertical-align: middle;
  display: inline-block;
}
.btn-social.btn-round {
  padding: 9px 10px;
}
.btn-social.btn-simple {
  padding: 9px 5px;
  font-size: 16px;
}
.btn-social.btn-simple .fa {
  font-size: 20px;
  position: relative;
  top: -2px;
  width: 24px;
}

.btn-facebook {
  border-color: #3b5998;
  color: #3b5998;
}
.btn-facebook:hover,
.btn-facebook:focus,
.btn-facebook:active,
.btn-facebook.active,
.open > .btn-facebook.dropdown-toggle {
  background-color: transparent;
  color: #3b5998;
  border-color: #3b5998;
  opacity: 1;
}
.btn-facebook:disabled,
.btn-facebook[disabled],
.btn-facebook.disabled {
  background-color: transparent;
  border-color: #3b5998;
}
.btn-facebook.btn-fill {
  color: #ffffff;
  background-color: #3b5998;
  opacity: 0.9;
}
.btn-facebook.btn-fill:hover,
.btn-facebook.btn-fill:focus,
.btn-facebook.btn-fill:active,
.btn-facebook.btn-fill.active,
.open > .btn-facebook.btn-fill.dropdown-toggle {
  background-color: #3b5998;
  color: #ffffff;
  opacity: 1;
}
.btn-twitter {
  border-color: #55acee;
  color: #55acee;
}
.btn-twitter:hover,
.btn-twitter:focus,
.btn-twitter:active,
.btn-twitter.active,
.open > .btn-twitter.dropdown-toggle {
  background-color: transparent;
  color: #55acee;
  border-color: #55acee;
  opacity: 1;
}
.btn-twitter:disabled,
.btn-twitter[disabled],
.btn-twitter.disabled {
  background-color: transparent;
  border-color: #55acee;
}
.btn-twitter.btn-fill {
  color: #ffffff;
  background-color: #55acee;
  opacity: 0.9;
}
.btn-twitter.btn-fill:hover,
.btn-twitter.btn-fill:focus,
.btn-twitter.btn-fill:active,
.btn-twitter.btn-fill.active,
.open > .btn-twitter.btn-fill.dropdown-toggle {
  background-color: #55acee;
  color: #ffffff;
  opacity: 1;
}

@media (min-width: 992px){
    .typo-line{
        padding-left: 140px;
        margin-bottom: 40px;
        position: relative;
    }

    .typo-line .category{
        transform: translateY(-50%);
        top: 50%;
        left: 0px;
        position: absolute;
    }
}

.all-icons [class*="pe-"]{
    font-size: 40px;
}
.all-icons input{
    border: 0;
}
.all-icons .font-icon-detail{
    text-align: center;
    padding: 45px 0px 30px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    margin: 15px 0;
}
.all-icons .font-icon-detail input{
    margin: 25px auto 0;
    width: 100%;
    text-align: center;
    display: block;
    color: #aaa;
    font-size: 13px;
}

#map{
    position:relative;
    width:100%;
    height: calc(100% - 60px);
}

.places-buttons .btn{
    margin-bottom: 30px
}
.sidebar .nav > li.active-pro{
    position: absolute;
    width: 100%;
    bottom: 10px;
}
.sidebar .nav > li.active-pro a{
    background: rgba(255, 255, 255, 0.14);
    opacity: 1;
    color: #FFFFFF;
}

.table-upgrade td:nth-child(2),
.table-upgrade td:nth-child(3){
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/demo.css"],"names":[],"mappings":"AAAA;;IAEI,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;AACA;IACI,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI;AACJ;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,qCAAqC;IACrC,UAAU;IACV,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,aAAa;IACb,0BAA0B;IAC1B,WAAW;AACf;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;;IAGI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,WAAW;AACf;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;MACM,gBAAgB;MAChB,eAAe;MACf,6BAA6B;MAC7B,SAAS;AACf;AACA;MACM,eAAe;MACf,kBAAkB;MAClB,mBAAmB;MACnB,sBAAsB;MACtB,sBAAsB;MACtB,eAAe;MACf,gBAAgB;MAChB,UAAU;MACV,eAAe;MACf,gBAAgB;MAChB,gBAAgB;MAChB,UAAU;AAChB;;AAEA;;IAEI,6BAA6B;AACjC;AACA;;IAEI,qCAAqC;AACzC;AACA;;IAEI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;AACd;;;AAGA;IACI;SAKK,2BAA2B;SAC3B,SAAS;SACT,UAAU;;SAEV,qBAAqB;IAC1B;IACA;SACK,UAAU;SAMV,2BAA2B;;SAE3B,qBAAqB;IAC1B;;IAEA;;QAEI,WAAW;QACX,qBAAqB;QACrB,kBAAkB;QAClB,QAAQ;QACR,WAAW;QACX,2BAA2B;QAC3B,mCAAmC;QACnC,gCAAgC;;IAEpC;IACA;QACI,0CAA0C;QAC1C,uCAAuC;QACvC,oCAAoC;QACpC,YAAY;IAChB;;IAEA;QACI,0CAA0C;QAC1C,+BAA+B;QAC/B,oCAAoC;QACpC,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,2BAA2B;QAC3B,QAAQ;QACR,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;AAEJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,UAAU;IACd;;IAEA;;;QAGI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,UAAU;AACZ;AACA;;;EAGE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;EAKE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,UAAU;AACZ;AACA;;;EAGE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;AACA;;;;;EAKE,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;IACI;QACI,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,2BAA2B;QAC3B,QAAQ;QACR,SAAS;QACT,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;AACnB;AACA;IACI,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI;AACJ;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,qCAAqC;IACrC,UAAU;IACV,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;AACtB","sourcesContent":[".fixed-plugin li > a,\n.fixed-plugin .badge{\n    transition: all .34s;\n    -webkit-transition: all .34s;\n    -moz-transition: all .34s;\n}\n\n.all-icons [class*=\"pe-\"]{\n    font-size: 40px;\n}\n.all-icons input{\n    border: 0;\n}\n.all-icons .font-icon-detail{\n    text-align: center;\n    padding: 45px 0px 30px;\n    border: 1px solid #e5e5e5;\n    border-radius: 6px;\n    margin: 15px 0;\n}\n.all-icons .font-icon-detail input{\n    margin: 25px auto 0;\n    width: 100%;\n    text-align: center;\n    display: block;\n    color: #aaa;\n    font-size: 13px;\n}\n\n#map{\n    position:relative;\n    width:100%;\n    height: calc(100% - 60px);\n}\n\n.places-buttons .btn{\n    margin-bottom: 30px\n}\n.sidebar .nav > li.active-pro{\n    position: absolute;\n    width: 100%;\n    bottom: 10px;\n}\n.sidebar .nav > li.active-pro a{\n    background: rgba(255, 255, 255, 0.14);\n    opacity: 1;\n    color: #FFFFFF;\n}\n\n.table-upgrade td:nth-child(2),\n.table-upgrade td:nth-child(3){\n    text-align: center;\n}\n\n.fixed-plugin{\n    position: absolute;\n    top: 180px;\n    right: 0;\n    width: 64px;\n    background: rgba(0,0,0,.3);\n    z-index: 1031;\n    border-radius: 8px 0 0 8px;\n    text-align: center;\n}\n.fixed-plugin .fa-cog{\n    color: #FFFFFF;\n    padding: 10px;\n    border-radius: 0 0 6px 6px;\n    width: auto;\n}\n.fixed-plugin .dropdown-menu{\n    right: 80px;\n    left: auto;\n    width: 290px;\n    border-radius: 10px;\n    padding: 0 10px;\n}\n.fixed-plugin .dropdown-menu:after, .fixed-plugin .dropdown-menu:before{\n    right: 10px;\n    margin-left: auto;\n    left: auto;\n}\n.fixed-plugin .fa-circle-thin{\n    color: #FFFFFF;\n}\n.fixed-plugin .active .fa-circle-thin{\n    color: #00bbff;\n}\n\n.footer-dropdown{\n\ttop: -120px !important;\n}\n\n.footer-dropdown:before, .footer-dropdown:after{\n\ttop: 300px !important;\n}\n\n.fixed-plugin .dropdown-menu > .active > a,\n.fixed-plugin .dropdown-menu > .active > a:hover,\n.fixed-plugin .dropdown-menu > .active > a:focus{\n    color: #777777;\n    text-align: center;\n}\n\n.fixed-plugin img{\n    border-radius: 0;\n    width: 100%;\n    max-height: 175px;\n    margin: 0 auto;\n}\n\n.fixed-plugin .badge{\n    border: 3px solid #FFFFFF;\n    border-radius: 50%;\n    cursor: pointer;\n    display: inline-block;\n    height: 23px;\n    margin-right: 5px;\n    position: relative;\n    width: 23px;\n}\n.fixed-plugin .badge.active,\n.fixed-plugin .badge:hover{\n    border-color: #00bbff;\n}\n\n.fixed-plugin .badge-white{\n    background-color: #FFFFFF;\n}\n.fixed-plugin .badge-black{\n    background-color: #1DC7EA;\n}\n.fixed-plugin .badge-azure{\n    background-color: #1DC7EA;\n}\n.fixed-plugin .badge-green{\n    background-color: #87CB16;\n}\n.fixed-plugin .badge-orange{\n    background-color: #FFA534;\n}\n.fixed-plugin .badge-purple{\n    background-color: #9368E9;\n}\n.fixed-plugin .badge-red{\n    background-color: #FB404B;\n}\n.fixed-plugin h5{\n    font-size: 14px;\n    margin: 10px;\n}\n.fixed-plugin .dropdown-menu li{\n    display: block;\n    padding: 5px 2px;\n    width: 25%;\n    float: left;\n}\n\n.fixed-plugin li.adjustments-line,\n.fixed-plugin li.header-title,\n.fixed-plugin li.button-container{\n    width: 100%;\n    height: 50px;\n    min-height: inherit;\n}\n.fixed-plugin .pro-title{\n    margin: 10px 0 5px 0;\n    text-align: center;\n}\n\n.fixed-plugin #sharrreTitle{\n    text-align: center;\n    padding: 10px 0;\n    height: 50px;\n}\n\n.fixed-plugin li.header-title{\n    height: 30px;\n    line-height: 40px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.fixed-plugin .adjustments-line p{\n    float: left;\n    display: inline-block;\n    margin-bottom: 0;\n    font-size: 1em;\n}\n.fixed-plugin .adjustments-line .switch{\n    float: right;\n}\n.fixed-plugin .dropdown-menu > li.adjustments-line > a{\n      padding-right: 0;\n      padding-left: 0;\n      border-bottom: 1px solid #ddd;\n      margin: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder{\n      font-size: 16px;\n      text-align: center;\n      border-radius: 10px;\n      background-color: #FFF;\n      border: 3px solid #FFF;\n      padding-left: 0;\n      padding-right: 0;\n      opacity: 1;\n      cursor: pointer;\n      max-height: 86px;\n      overflow: hidden;\n      padding: 0;\n}\n\n.fixed-plugin .dropdown-menu > li > a.switch-trigger:hover,\n.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus{\n    background-color: transparent;\n}\n.fixed-plugin .dropdown-menu > li:hover > a.img-holder,\n.fixed-plugin .dropdown-menu > li:focus > a.img-holder{\n    border-color: rgba(0, 187, 255, 0.53);;\n}\n.fixed-plugin .dropdown-menu > .active > a.img-holder,\n.fixed-plugin .dropdown-menu > .active > a.img-holder{\n    border-color: #00bbff;\n    background-color: #FFFFFF;\n}\n\n.fixed-plugin .dropdown-menu > li > a img{\n    margin-top: auto;\n}\n\n.fixed-plugin .btn-social{\n    width: 50%;\n    display: block;\n    width: 48%;\n    float: left;\n    font-weight: 600;\n}\n.fixed-plugin .btn-social i{\n    margin-right: 5px;\n}\n.fixed-plugin .btn-social:first-child{\n    margin-right: 2%;\n}\n\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus{\n    opacity: 1;\n}\n\n\n@media (min-width: 992px){\n    .fixed-plugin .dropdown .dropdown-menu{\n         -webkit-transform: translateY(-50%);\n         -moz-transform: translateY(-50%);\n         -o-transform: translateY(-50%);\n         -ms-transform: translateY(-50%);\n         transform: translateY(-50%);\n         top: 27px;\n         opacity: 0;\n\n         transform-origin: 0 0;\n    }\n    .fixed-plugin .dropdown.open .dropdown-menu{\n         opacity: 1;\n\n         -webkit-transform: translateY(-50%);\n         -moz-transform: translateY(-50%);\n         -o-transform: translateY(-50%);\n         -ms-transform: translateY(-50%);\n         transform: translateY(-50%);\n\n         transform-origin: 0 0;\n    }\n\n    .fixed-plugin .dropdown-menu:before,\n    .fixed-plugin .dropdown-menu:after{\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        top: 50%;\n        width: 16px;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(-50%);\n        -moz-transform: translateY(-50%);\n\n    }\n    .fixed-plugin .dropdown-menu:before{\n        border-bottom: 16px solid rgba(0, 0, 0, 0);\n        border-left: 16px solid rgba(0,0,0,0.2);\n        border-top: 16px solid rgba(0,0,0,0);\n        right: -16px;\n    }\n\n    .fixed-plugin .dropdown-menu:after{\n        border-bottom: 16px solid rgba(0, 0, 0, 0);\n        border-left: 16px solid #FFFFFF;\n        border-top: 16px solid rgba(0,0,0,0);\n        right: -15px;\n    }\n\n    .typo-line{\n        padding-left: 140px;\n        margin-bottom: 40px;\n        position: relative;\n    }\n\n    .typo-line .category{\n        transform: translateY(-50%);\n        top: 50%;\n        left: 0px;\n        position: absolute;\n    }\n\n    .fixed-plugin{\n        top: 300px;\n    }\n\n}\n\n@media (max-width: 991px){\n    .fixed-plugin .dropdown-menu{\n        right: 60px;\n        width: 220px;\n    }\n    .fixed-plugin .dropdown-menu li{\n        width: 50%;\n    }\n\n    .fixed-plugin li.adjustments-line,\n    .fixed-plugin li.header-title,\n    .fixed-plugin li.button-container{\n        width: 100%;\n        height: 55px;\n        min-height: inherit;\n    }\n\n    .fixed-plugin .adjustments-line .switch{\n        float: right;\n        margin: 0 0px;\n    }\n\n    .fixed-plugin li.header-title{\n        height: 40px;\n    }\n    .fixed-plugin .dropdown .dropdown-menu{\n        top: -170px;\n    }\n}\n\n.btn-social {\n  opacity: 0.85;\n  padding: 8px 9px;\n}\n.btn-social .fa {\n  font-size: 18px;\n  vertical-align: middle;\n  display: inline-block;\n}\n.btn-social.btn-round {\n  padding: 9px 10px;\n}\n.btn-social.btn-simple {\n  padding: 9px 5px;\n  font-size: 16px;\n}\n.btn-social.btn-simple .fa {\n  font-size: 20px;\n  position: relative;\n  top: -2px;\n  width: 24px;\n}\n\n.btn-facebook {\n  border-color: #3b5998;\n  color: #3b5998;\n}\n.btn-facebook:hover,\n.btn-facebook:focus,\n.btn-facebook:active,\n.btn-facebook.active,\n.open > .btn-facebook.dropdown-toggle {\n  background-color: transparent;\n  color: #3b5998;\n  border-color: #3b5998;\n  opacity: 1;\n}\n.btn-facebook:disabled,\n.btn-facebook[disabled],\n.btn-facebook.disabled {\n  background-color: transparent;\n  border-color: #3b5998;\n}\n.btn-facebook.btn-fill {\n  color: #ffffff;\n  background-color: #3b5998;\n  opacity: 0.9;\n}\n.btn-facebook.btn-fill:hover,\n.btn-facebook.btn-fill:focus,\n.btn-facebook.btn-fill:active,\n.btn-facebook.btn-fill.active,\n.open > .btn-facebook.btn-fill.dropdown-toggle {\n  background-color: #3b5998;\n  color: #ffffff;\n  opacity: 1;\n}\n.btn-twitter {\n  border-color: #55acee;\n  color: #55acee;\n}\n.btn-twitter:hover,\n.btn-twitter:focus,\n.btn-twitter:active,\n.btn-twitter.active,\n.open > .btn-twitter.dropdown-toggle {\n  background-color: transparent;\n  color: #55acee;\n  border-color: #55acee;\n  opacity: 1;\n}\n.btn-twitter:disabled,\n.btn-twitter[disabled],\n.btn-twitter.disabled {\n  background-color: transparent;\n  border-color: #55acee;\n}\n.btn-twitter.btn-fill {\n  color: #ffffff;\n  background-color: #55acee;\n  opacity: 0.9;\n}\n.btn-twitter.btn-fill:hover,\n.btn-twitter.btn-fill:focus,\n.btn-twitter.btn-fill:active,\n.btn-twitter.btn-fill.active,\n.open > .btn-twitter.btn-fill.dropdown-toggle {\n  background-color: #55acee;\n  color: #ffffff;\n  opacity: 1;\n}\n\n@media (min-width: 992px){\n    .typo-line{\n        padding-left: 140px;\n        margin-bottom: 40px;\n        position: relative;\n    }\n\n    .typo-line .category{\n        transform: translateY(-50%);\n        top: 50%;\n        left: 0px;\n        position: absolute;\n    }\n}\n\n.all-icons [class*=\"pe-\"]{\n    font-size: 40px;\n}\n.all-icons input{\n    border: 0;\n}\n.all-icons .font-icon-detail{\n    text-align: center;\n    padding: 45px 0px 30px;\n    border: 1px solid #e5e5e5;\n    border-radius: 6px;\n    margin: 15px 0;\n}\n.all-icons .font-icon-detail input{\n    margin: 25px auto 0;\n    width: 100%;\n    text-align: center;\n    display: block;\n    color: #aaa;\n    font-size: 13px;\n}\n\n#map{\n    position:relative;\n    width:100%;\n    height: calc(100% - 60px);\n}\n\n.places-buttons .btn{\n    margin-bottom: 30px\n}\n.sidebar .nav > li.active-pro{\n    position: absolute;\n    width: 100%;\n    bottom: 10px;\n}\n.sidebar .nav > li.active-pro a{\n    background: rgba(255, 255, 255, 0.14);\n    opacity: 1;\n    color: #FFFFFF;\n}\n\n.table-upgrade td:nth-child(2),\n.table-upgrade td:nth-child(3){\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
